<script>
	import { DateTime } from 'luxon';
	  import { modalReservation } from '../../../store.js';

	export let reservation;
	export let grid;
	export let user;

	let tooltipX = 0;
	let tooltipY = 0;

	const getDays = (item) => {
	  const start = DateTime.fromISO(item.dateFrom, { setZone: true });
	  const end   = DateTime.fromISO(item.dateTo, { setZone: true });

	  return end.diff(start, 'days').toObject().days;
	}

	const getTextPadding = (item) => {
	  const length = getDays(item);
	  const offset = getOffset(item.dateFrom);

	  const left  = offset < 0 && offset + length > 0 ? Math.abs(offset) * 51 - 26 : 0;
	  const right = offset + length > grid.length ? (offset + length - grid.length) * 51 + 26 : 0;

	  return { right: right, left: left };
	};

	const getOffset = (date) => {
	  const start = DateTime.fromISO(date, { setZone: true });

	  if (grid.length === 0) return 0;

	  const gridStart = grid[0].date.setZone('utc', { keepLocalTime: true });
	  return start.diff(gridStart, 'days').toObject().days;
	};

	const handleMouseOver = (e) => {
	  tooltipX = e.clientX;
	  tooltipY = e.clientY;
	}

	const pickColorByStatus = (status) => {
	  switch(status){
			  case 'Confirmed':
				  return 'reservation-confirmed'
			  case 'Pending':
				  return 'reservation-pending'
			  case 'Inquiry':
				  return 'reservation-inquiry'
			  default:
				  return '';
		  }
	};

	const width   = getDays(reservation) * 51 - 2;
	$: padding = getTextPadding(reservation, grid);
	$: offset  = getOffset(reservation.dateFrom, grid) * 51 + 26;
  </script>
  <a href="#modal"
	on:mousemove={handleMouseOver}
	on:click={modalReservation.set(reservation)}
	class='item  { reservation.purpose === 'Host Booking' || reservation.purpose === 'Friend of host Booking'? 'hostBooking' : 'reservation' +' '+ pickColorByStatus(reservation.status)}'
	class:cleaner='{user.accountRole.toLowerCase() === 'cleaner'}'
	style='width: {width}px;  left: {offset}px; top: {10 + (50 * (reservation.row - 1))}px;'>
	<div class='item-name' style='padding-left: {padding.left}px;padding-right: {padding.right}px' >{reservation.guestFirstName} {reservation.guestLastName}</div>
	<span class='tip'  style='left: {tooltipX}px; top:{tooltipY}px'>
	  <p class='blue-font'><b>{DateTime.fromISO(reservation.dateFrom,{setZone : true}).toLocaleString()} - {DateTime.fromISO(reservation.dateTo,{setZone : true}).toLocaleString()}</b></p>
	  <p class='blue-font'>{reservation.nights}  nights</p>
	  <p class='name'><b>{reservation.guestFirstName} {reservation.guestLastName}</b></p>
	  <p>{reservation.numberOfGuests} guests</p>
	  {#if reservation.airbetterCheckin}
		<p ><b>Check-in: </b> {reservation.airbetterCheckin}</p>
	  {/if}

	  {#if reservation.airbetterCheckout}
		<p ><b>Check-out: </b> {reservation.airbetterCheckout}</p>
	  {/if}

	  <p class='channel'>{reservation.channelId.companyName}</p>

	  {#if reservation.airbetterDescription}
		<p class='pink-font'><b>{reservation.airbetterDescription}</b></p>
	  {/if}

	  {#if reservation.airbetterDescription}
		<p><b>Comments</b></p>
		<p >{reservation.airbetterDescription}</p>
	  {/if}
	</span>
  </a>

  <style>
	.item {
		  position: absolute;
		  left: 0;
		  height:30px;
		  text-align: center;
		  font-size:11px;
		  color:white;
		  line-height: 30px;
		  font-style: italic;
		  background-color: #D0CECF;
		  border-radius: 15px;
		  text-transform: uppercase;
	  }

	  .item.hostBooking{
		  color : black;
		  background-color: #FFFFFF;
		  border:2px red solid;
		  white-space: nowrap;
		  overflow: hidden;
		  }

	.item.reservation.cleaner {
		  display:block;
		  background-image: linear-gradient(90deg, rgba(66,172,173,1) 0%, rgba(239,64,100,1) 100%);
		  height:15px;
		  font-size:0;
		  border-radius: 0;
		  z-index:0;
		  margin-left: 24px;
		  margin-top:7px;
	  }

	.item.cleaner:hover .tip {
	  display: none;
	}

	.item.reservation{
		  background-color: #F04066;
	  }

	  .reservation-confirmed {
		  background-color: #F04066 !important;
	  }
	  .reservation-pending {
		  background-color: #FAA15E !important;
	  }
	  .reservation-inquiry {
		  background-color: #F9B3D6 !important;
	  }

	.tip {
		  font-style: normal;
		  text-transform: none;
		  text-align: left;
		  border: 1px solid #D0CFCB;
		  background-color: white;
		  position: fixed;
		  padding: 10px;
		  z-index: 5;
		  display: none;
		  width:200px;
		  transform: translateX(-50%) translateY(-120%);
		  color:black;
		  font-size:13px;
		  line-height:20px;
		  font-weight:normal;
	  }
	  .tip p{
		  margin:0;
	  }
	  .tip p.name{
		  font-size:14px;
		  margin:4px 0;
	  }

	  .tip p.channel{
		  text-decoration: underline;
	  }

	.item:hover .tip {
		  display: block;
	  }

	  .tip::before{
		  width: 0;
		  height: 0;
		  border-left: 10px solid transparent;
		  border-right: 10px solid transparent;
		  border-top: 10px solid #D0CFCB;
		  content: " ";
		  position: absolute;
		  bottom:-10px;
		  left:100px;
	  }

	  .tip::after{
		  width: 0;
		  height: 0;
		  border-left: 8px solid transparent;
		  border-right: 8px solid transparent;
		  border-top: 9px solid white;
		  content: " ";
		  position: absolute;
		  bottom:-9px;
		  left:102px;
	  }
  </style>
